<template>
  <h4
    :class="['grey--text', 'text--darken-2', {'mt-10':!noMarginTop}]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
  </h4>
</template>

<script>
  export default {
    // standard content title of this project
    name: 'BaseTitle',

    props: {
      noMarginTop: {type: Boolean, default: false}
    }
  }
</script>

<style lang="scss" scoped>

</style>